import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import folder_alt from "../../assets/folder_alt.svg";
import Header from "../../Header/Header";
import foodbrand from "../../assets/foodbrand@2x.png";
import "./style.css";

function HomeLicConducir() {
  const navigate = useNavigate();
  const [strCPV, setStrCPV] = useState("");

  useEffect(() => {
    setStrCPV(localStorage.getItem("sCpv"));
  });

  const onTest = async () => {
    navigate("/TipoLicencia", {
      state: { user: "userTest" },
    });
  };

  return (
    <>
      <div className="initBack_P2 animate__animated animate__fadeIn">
        <Header
          imgBack={true}
          rutaBack="/PantallaBase27"
          title="Licencia de Conducir"
          name="HomeLicConducir"
        />

        {/* <div className="containerRender"> */}
        <div className="containerInfo_P2">
          <div className="containerIdent_P2">
            <div className="txtOp_P2">Operación/Operation</div>
            <div className="txtVer_P2">Verificación de Licencia de Conducir</div>
            <div className="txtCpv_P2">CPV/PVC</div>
            <div className="txtVer_P2">{strCPV}</div>
            <div className="txtOp_P2">Remitente/Sender</div>
            <div className="txtVer_P2">Business Prey</div>
          </div>
          <div className="containerDoc_P2">
            <div className="txtReq_P2">Esta operación requiere:</div>
          </div>
          <div className="container_data_operation">
            <img src={folder_alt} align="left" className="imgFol_P2" />
            <div className="txtDocReq_P2">Licencia de Conducir</div>
            <div className="txtIdenOf_P2">Licencia de conducir vigente.</div>
          </div>
        </div>
        {/* </div> */}
        <div className="footer">
          <div className="containerCont_P2">
            <button className="button_P2" onClick={onTest}>
              <span className="txtButton_P2">Confirmar</span>
            </button>
          </div>
          <div className="imageContainer_P2">
            <img src={foodbrand} className="imgFooter_P2" />
          </div>
        </div>
      </div>
    </>
  );
}

export default HomeLicConducir;
